import { SET_GROUP } from "../constant";

const GroupReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_GROUP:
            return {
                ...state,
                data: action.data
            }
        default:
            return state
    }
}

export default GroupReducer